// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160202/js/" + chunkId + "." + {"44":"8103fb7f","225":"f9db92e5","481":"dc9f3257","486":"255a5d16","770":"3420e80d"}[chunkId] + ".0.3194698872955344.chunk.js";
};